/* eslint-disable camelcase */
import useIsFreelancerLoggedIn from 'hooks/use-is-freelancer-logged-in';
import { useApiOrganisationLocationsList } from 'state/__generated__/tadaahAPI';

interface UseGetOrganisationLocationsHandler {
  locations: TmpLocationType[];
  isLoading: boolean;
  error: string | undefined;
}

type UseGetOrganisationLocationsParams = {
  organisationId: string;
};

export type TmpLocationType = {
  id: number;
  name: string;
  address: string;
  postal_code: string;
  city: string;
  phone_number: string;
};

const useGetOrganisationLocations = ({
  organisationId,
}: UseGetOrganisationLocationsParams): UseGetOrganisationLocationsHandler => {
  const isLoggedIn = useIsFreelancerLoggedIn();

  const { data, isLoading, error } = useApiOrganisationLocationsList(
    organisationId,
    {
      query: {
        enabled: isLoggedIn,
        queryKey: ['location-options', organisationId],
      },
    },
  );

  return {
    error: error?.message,
    isLoading,
    locations: (data?.data as unknown as TmpLocationType[]) ?? [],
  };
};

export default useGetOrganisationLocations;
